const _ = {
  actions: {
    GetNewsCateList({ commit, state }, params) {
      return mm
        .http({
          url: '/api/news/category/list',
          method: 'get',
          params: {
            ...params
          }
        })
        .then(({ data }) => {
          return data
        })
    },
    GetNewsData({ commit, state }, params) {
      return mm
        .http({
          url: '/api/datasource/news',
          method: 'get',
          params: {
            ...params
          }
        })
        .then(({ data }) => {
          return data
        })
    },
    GetNewsList({ commit, state }, params) {
      return mm
        .http({
          url: '/api/news/list',
          method: 'get',
          params: {
            a_langset_id: mm.store.state.currentLanguage,
            ...params
          }
        })
        .then(({ data }) => {
          return data
        })
    },
  }
}

export default _
